import { Button, Row, Col } from 'antd';

export default function StepActions({
  isLoading,
  isBackDisabled,
  isNextDisabled,
  next,
  back,
  cancelPatch,
  currentStep
}) {
  return (
    <Row>
      <Col span={2}>
        <Button
          block
          htmlType="button"
          disabled={isBackDisabled || isLoading}
          onClick={back}>
          Back
        </Button>
      </Col>
      <Col span={2} offset={17}>
          <Button
            danger
            htmlType="button"
            style={{gap: '4px'}}
            onClick={cancelPatch}
            disabled={isLoading}>
            Cancel
          </Button>
      </Col>
      <Col span={3}>
        <Button
          block
          type="primary"
          htmlType="button"
          size="large"
          onClick={next}
          loading={isLoading}
          disabled={isNextDisabled}>
          { currentStep === 3 ? 'Done' : 'Next'}
        </Button>
      </Col>
    </Row>
  );
}